// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"UserMenuItem-module_menuItem_3NYMD","promotional":"UserMenuItem-module_promotional_1kJlr"};